import AbstractService from "./AbstractService";
import NexusService from "./NexusService";
import FeatureFlagService from "./FeatureFlagService";

export default class ClientJobRequestService extends AbstractService {
	static clientJobReqeuestsApi = NexusService.clientJobReqeuestsApi;

	static apiCoreEndpointsFeature = "use_api_core_endpoints_client_job_requests";

	static getJobRequests(pageNumber) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			const request = {
				pageNumber,
				status: 1,
				displayCount: 25,
			};
			return this.clientJobReqeuestsApi.getPaginatedClientJobRequests(request);
		}
		return this.get({
			endpoint: "/clientjobrequest/1",
			queryParams: { pageNumber, status: 1, displayCount: 25 },
		});
	}

	static getJobRequestDetails(requestId) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			const request = {
				id: requestId,
			};
			return this.clientJobReqeuestsApi.getClientJobRequest(request);
		}
		return this.get({ endpoint: `/clientjobrequest/${requestId}` });
	}

	static removeJobRequest(requestId) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			const request = {
				id: requestId,
			};
			return this.clientJobReqeuestsApi.deleteClientJobRequest(request);
		}
		return this.put({ endpoint: `/clientjobrequests/${requestId}/status/3` });
	}
}
